import React, { useState, useEffect } from 'react';
import { calculateReactivationTime } from 'utils/functions';
import { isBrandOpenNow } from './functions';
import { RestaurantType } from 'models/brand.model';

type Props = {
  onClick: (id: string) => void;
  brand: RestaurantType;
};
const BrandCard = ({ onClick, brand }: Props) => {
  const [isBrandClosed, setIsBrandClosed] = useState(false);
  const [reactivationTime, setReactivationTime] = useState(
    calculateReactivationTime(brand.reactivation_time)
  );

  useEffect(() => {
    const intervalId = setInterval(() => {
      const time = calculateReactivationTime(brand.reactivation_time);
      setReactivationTime(time);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [brand.reactivation_time]);

  useEffect(() => {
    if (brand.is_busy && reactivationTime > 0) setIsBrandClosed(false);
    else setIsBrandClosed(!isBrandOpenNow(brand));
  }, [reactivationTime, brand]);

  return (
    <button
      disabled={isBrandClosed}
      onClick={() => onClick(brand.id)}
      className={`border border-[#EAEBEB] p-4 rounded-md ${
        isBrandClosed ? 'text-gray-4' : 'text-[#1A1A1A] hover:text-black'
      }`}>
      <h3 className='font-medium'>{brand.name}</h3>
    </button>
  );
};

export default BrandCard;
